import { createRoot, DEV } from "solid-js"
import { unwrap } from "solid-js/store"
import type { Engine } from "../../lib/core/engine/Engine.type"
import Unexpected from "../../lib/Exception/Unexpected.class"

export default function createSharedCachedFactory<T>(fn: (engine: Engine) => T) {
  const cache = new WeakMap<Engine, T>

  return (engine: Engine) => {
    if (DEV) {
      if (!engine) {
        throw new Unexpected('!engine')
      }
    }
    const unwrappedEngine = unwrap(engine)
    // console.log('unwrappedEngine', unwrappedEngine, 'engine', engine)

    let memo = cache.get(unwrappedEngine)
    if (!memo) {
      memo = createRoot((disposeRoot) => {
        unwrappedEngine.gcELL().push(disposeRoot)
        return fn(engine)
      })
  
      cache.set(unwrappedEngine, memo)
    }
    return memo
  }
}
